export const BRANDS_WITH_REQUIRED_TAGS_GROUP = [386_760];
